import { SUBSTATUS } from "Services/Status/Substatus.types";
import { NOTIFICATIONTYPE } from "Store/Notification/ActionTypes";
import { ACTION_TYPE, getActionTypes } from "Store/Shared/Actions/Helpers";
import { API_URL } from "Store/Shared/Middleware/API/Constants";
import ACTIONS, { FETCH_ALL_VACANCY, FETCH_VACANCY, FETCH_VACANCY_DATASET, SAVE_VACANCY, SAVE_VACANCY_STATUS, VACANCY } from "./ActionTypes";
import { VacancyId } from "./PropTypes";
import {fetchCandidateV2} from 'Store/Candidate/Actions';

export const fetchVacancyOverviewByPagenumber = (
    overview_fields: string[],
    pageNumber: number = 1,
    filters: any = false,
    forceFetch: boolean = false
): ACTION_TYPE => {
    let flattenFilters = '';
    const filterKeys = Object.keys(filters);
    if (filterKeys) {
        for (const filterKey of filterKeys) {
            let values = filters[filterKey];
            if (Array.isArray(filters[filterKey])) {
                values = values.join(',');
            }
            flattenFilters += `&filter[${filterKey}]=${values}`;
        }
    }

    return {
        types: getActionTypes(ACTIONS.FETCH_VACANCY_OVERVIEW_PAGE),
        shouldCallAPI: ({ vacancies }) => forceFetch || !vacancies._isFetchingPage.includes(pageNumber),
        callAPI: {
            url: `/api/v2/overview?entity=vacancy&page=${pageNumber}&overview_fields=${overview_fields ?? ''}${flattenFilters}`
        },
        payload: {
            page_number: pageNumber,
            isFiltering: flattenFilters.length > 0
        }
    }
}



export const createVacancy = (data: any): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.CREATE_VACANCY),
    callAPI: {
        method: 'POST',
        url: '/api/v2/vacancies',
        body: data
    }
});

export const createVacancyValues = (id: VacancyId, body: any): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.CREATE_VACANCY_VALUES),
    callAPI: {
        method: 'POST',
        url: `/api/v2/vacancies/${id}/values`,
        body: body
    },
    notification: {
        [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol aangepast',
        [NOTIFICATIONTYPE.ERROR]: 'Aanpassing mislukt'
    },
    callback: fetchVacancyV2(id)
})

export const backgroundCreateVacancyValues = (id: VacancyId, body: any): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.BACKGROUND_CREATE_VACANCY_VALUES),
    callAPI: {
        method: 'POST',
        url: `/api/v2/vacancies/${id}/values`,
        body: body
    },
    notification: {
        [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol aangepast',
        [NOTIFICATIONTYPE.ERROR]: 'Aanpassing mislukt'
    },
})

export const fetchAllVacancies = (): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.FETCH_ALL_VACANCIES),
    shouldCallAPI: state => state.vacancies._forceFetch,
    callAPI: {
        url: '/api/v2/vacancies'
    }
});

export const fetchVacancyV2 = (id: VacancyId): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.FETCH_VACANCY),
    callAPI: {
        url: `/api/v2/vacancies/${id}`
    },
    parralel: fetchVacancyValues(id)
});

export const fetchVacancyValues = (id: VacancyId): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.FETCH_VACANCY_VALUES),
    callAPI: {
        url: `/api/v2/vacancies/${id}/values`
    }
});

export const fetchVacancyConcept = (): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.FETCH_VACANCY_CONCEPT),
    shouldCallAPI: state => state.vacancies._forceFetch,
    callAPI: { url: `/api/v2/vacancies?substatus=${SUBSTATUS.ACTIVE.RECORD_CONCEPT}` }
});

export const updateVacancyValues = (id: VacancyId, body: any): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.UPDATE_VACANCY_VALUES),
    callAPI: {
        method: 'PATCH',
        url: `/api/v2/vacancies/${id}/values`,
        body: body
    },
    notification: {
        [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol aangepast',
        [NOTIFICATIONTYPE.ERROR]: 'Aanpassing mislukt'
    },
    callback: fetchVacancyV2(id)
})

export const upsertVacancyValues = (id: any, data: any) => ({
    types: getActionTypes(ACTIONS.UPSERT_VACANCY_VALUES),
    callAPI: {
        method: 'PUT',
        url: `/api/v2/vacancies/${id}/values`,
        body: {
            values: data
        }
    }
})

export const backgroundUpdateVacancyValues = (id: VacancyId, body: any): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.BACKGROUND_UPDATE_VACANCY_VALUES),
    callAPI: {
        method: 'PATCH',
        url: `/api/v2/vacancies/${id}/values`,
        body: body
    },
    notification: {
        [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol aangepast',
        [NOTIFICATIONTYPE.ERROR]: 'Aanpassing mislukt'
    }
})

export const updateVacancy = (id: any, body: any): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.UPDATE_VACANCY),
    callAPI: {
        method: 'PATCH',
        url: `/api/v2/vacancies/${id}`,
        body: body
    },
    notification: {
        [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol aangepast',
        [NOTIFICATIONTYPE.ERROR]: 'Aanpassing mislukt'
    }
})

export const deleteVacancy = (id: VacancyId): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.DELETE_VACANCY),
    callAPI: {
        method: 'DELETE',
        url: `/api/v2/vacancies/${id}`
    },
    notification: {
        [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol verwijderd',
        [NOTIFICATIONTYPE.ERROR]: 'Verwijderen mislukt'
    },
})


export function fetchAllVacancy(page, searchFilter, overviewFilter) {
    let urlParams = '';
    if (searchFilter) {
        urlParams += `&searchFilter=${searchFilter}`
    }

    Object.keys(overviewFilter)?.map((i) => {
        urlParams += `&${encodeURIComponent(i)}=${overviewFilter[i]}`;
    });
    
    return {
        types: [
            FETCH_ALL_VACANCY.REQUEST,
            FETCH_ALL_VACANCY.SUCCESS,
            FETCH_ALL_VACANCY.FAILURE
        ],
        shouldCallAPI: (state: any) => true,
        callAPI: (accessToken: any) => fetch(
            API_URL + `/api/overview?entity=vacancy&page=${page}${urlParams}`,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            })
    }
}

export function fetchVacancy(id: string) {
    return {
        types: [
            FETCH_VACANCY.REQUEST,
            FETCH_VACANCY.SUCCESS,
            FETCH_VACANCY.FAILURE
        ],
        shouldCallAPI: (state: any) => true,
        callAPI: (accessToken: any) => fetch(
            API_URL + `/api/vacancies/${id}`,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            })
    }
}

export function saveVacancy(candidateId: any, data: any) {
    return {
        types: [
            SAVE_VACANCY.REQUEST,
            SAVE_VACANCY.SUCCESS,
            SAVE_VACANCY.FAILURE
        ],
        notification: {
            [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol opgeslagen',
            [NOTIFICATIONTYPE.ERROR]: 'Opslaan mislukt'
        },
        shouldCallAPI: () => true,
        callAPI: (accessToken: any) => fetch(
            API_URL + `/api/vacancies/${candidateId}`,
            {
                method: 'PUT',
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
                body: JSON.stringify(data)
            }),
        callback: fetchVacancyValues(candidateId)
    }
}

export function saveVacancyEntity(candidateId: any, data: any) {
    return {
        types: [
            SAVE_VACANCY_STATUS.REQUEST,
            SAVE_VACANCY_STATUS.SUCCESS,
            SAVE_VACANCY_STATUS.FAILURE
        ],
        notification: {
            [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol opgeslagen',
            [NOTIFICATIONTYPE.ERROR]: 'Opslaan mislukt'
        },
        shouldCallAPI: () => true,
        callAPI: (accessToken: any) => fetch(
            API_URL + `/api/vacancies/${candidateId}`,
            {
                method: 'PATCH',
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
                body: JSON.stringify(data)
            })
    }
}

export function editVacancy(candidateId: any, fieldId: any, valueId: any, value: any) {
    return {
        type: VACANCY.EDIT,
        payload: {
            candidateId: candidateId,
            fieldId: fieldId,
            valueId: valueId,
            value: value
        }
    }
}

export function resetVacancy(candidateId: any, fieldIds: any) {
    return {
        type: VACANCY.RESET,
        payload: {
            candidateId: candidateId,
            fieldIds: fieldIds
        }
    }
}

export function fetchVacancyDataset() {
    return {
        types: [
            FETCH_VACANCY_DATASET.REQUEST,
            FETCH_VACANCY_DATASET.SUCCESS,
            FETCH_VACANCY_DATASET.FAILURE
        ],
        shouldCallAPI: (state: any) => !state.vacancies.isLoading,
        callAPI: (accessToken: any) => fetch(
            API_URL + `/api/vacancies/dataset`,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            })
    }
}